import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getTestLabels } from '../../../../utils/getTestLabels.js';
import style from './LoaderSvgBitiba.module.scss.js';

const { componentTestLabel } = getTestLabels('LoaderSvgBitiba');
/**
 * @deprecated use LoaderSvg instead
 *
 * @param {string} variant - (optional) Can be set to `white` for a white loading indicator. For use against darker backgrounds.
 */
const LoaderSvgBitiba = forwardRef((props, ref) => {
    const { className, variant, ...otherProps } = props;
    return (jsx("div", { "data-zta": componentTestLabel, ref: ref, ...otherProps, className: classNames(className, style['z-loader-circle'], {
            [style[`z-loader-circle--${variant}`]]: variant,
        }) }));
});
LoaderSvgBitiba.displayName = 'LoaderSvgBitiba';

export { LoaderSvgBitiba };
//# sourceMappingURL=LoaderSvgBitiba.js.map
